import React from "react";
import LoginComponent from "../components/Login/Login";

const Login = () => {
  return <LoginComponent />;
};

export default Login;
